import { render, staticRenderFns } from "./SimpleAutobuyersMultiBox.vue?vue&type=template&id=2bc353a8&scoped=true"
import script from "./SimpleAutobuyersMultiBox.vue?vue&type=script&lang=js"
export * from "./SimpleAutobuyersMultiBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc353a8",
  null
  
)

export default component.exports